import { setIsVehicleKnown } from '@/context/borrower';
import { setIsAssetKnownViaParams } from '@/context/display';
import { store } from '@/context/store';

export function setInitialVehicleIsKnown(
    buildYear: string | null,
    make: string | null,
    model: string | null,
    variant: string | null,
    nvic: string | null,
    vin: string | null
): void {
    // Year, Make, Model all required
    if (buildYear && make && model) {
        store.dispatch(setIsVehicleKnown(true));
        store.dispatch(setIsAssetKnownViaParams(true));
        return;
    }

    // If nvic or vin, lookupVehicle should take care of it
    if (nvic || vin) {
        store.dispatch(setIsVehicleKnown(true));
        store.dispatch(setIsAssetKnownViaParams(true));
        return;
    }

    // For test drive flow, if we have any vehicle information, mark as known
    const state = store.getState();
    const userFlow = state.displayReducer.partner.userFlow;
    const initialJourney = state.displayReducer.initialJourney;

    if (userFlow === 'TEST_DRIVE' || initialJourney === 'TEST_DRIVE') {
        if (buildYear || make || model || variant || nvic || vin) {
            store.dispatch(setIsVehicleKnown(true));
            store.dispatch(setIsAssetKnownViaParams(true));
            return;
        }
    }
}
